import axios from "src/utils/axios";

// export const ordersSchool = async ({ queryKey, signal }) => {
//   const { data } = await axios("orders/company/school/" + queryKey[1]);
//   return data.data;
// };
export const ordersSchool = async ({ queryKey, signal }) => {
  const [ _, schoolID, packageID, status, fromDate, toDate, shippingType, years, ] = queryKey;

  const queryParams = new URLSearchParams();

  if (packageID) queryParams.append("packageID", packageID);
  if (status) queryParams.append("status", status);
  if (fromDate) queryParams.append("fromDate", fromDate);
  if (toDate) queryParams.append("toDate", toDate);
  if (shippingType) queryParams.append("shippingType", shippingType);
  if (years?.length) {
    years.forEach(year => queryParams.append("years", year));
  } else {
    queryParams.append("years", new Date().getFullYear().toString());
  }

  const url = `orders/company/school/${schoolID}?${queryParams.toString()}`;
  const { data } = await axios.get(url, { signal });
  return data.data;
};
export const ordersList = async ({ queryKey, signal }) => {
  const req = {
    schoolID: queryKey[1],
    packageID: queryKey[2] === "" ? undefined : +queryKey[2],
    status: queryKey[3] === "" ? undefined : queryKey[3],
    fromDate: queryKey[4] ?? undefined,
    toDate: queryKey[5] ?? undefined,
    year: queryKey[6] && queryKey[6].length ? queryKey[6].join(',') : new Date().getFullYear().toString(),

  };
  const { data } = await axios.post("orders/school/list", req, {signal});
  return data.data;
};
export const ordersSingleOrder = async ({ queryKey, signal }) => {
  const { data } = await axios("orders/singleOrder/" + queryKey[1]);
  return data.data;
};
export const masterGetData = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    { tableName: queryKey[1], page: +queryKey[2] + 1, limit: queryKey[3] },
    { signal }
  );
  return data?.data[0] || [];
};
export const masterGetDataByid = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    {
      tableName: queryKey[1],
      page: +queryKey[2] + 1,
      limit: queryKey[3],
      where: [{ field: queryKey[4], operator: "=", value: queryKey[5] }],
    },
    { signal }
  );
  return data?.data[0] || [];
};

export const invoiceGet = async ({ queryKey, signal }) => {
  const { data } = await axios(`/invoice/admin/get/${queryKey[1]}`, { signal });
  console.log(data.data, "data.data");
  return data?.data[0] || {};
};

export const packageAdminList = async ({ queryKey, signal }) => {
  const { data } = await axios("package/admin/list/" + queryKey[1], {
    signal,
  });
  return data.data;
};

export const packageAdminConstituents = async id => {
  const { data } = await axios("package/admin/constituents/" + id);
  return data.data;
};
export const cartAdminAdd = async ({ signal, req }) => {
  const { data } = await axios.post("cart/school/add", req, { signal });
  return data;
};

export const masterSaveData = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.patch("master/updateData/", req, { signal });
    return data.data;
  }
  const { data } = await axios.post("master/addData/", req, { signal });
  return data.data;
};

export const addRider = async ({ signal, req }) => {
  const { data } = await axios.post("delivery/addRider", req, { signal });
  return data.data;
};
export const uploadImage = async (type, req) => {
  const { data } = await axios.post(`/upload/delivery/image/${type}`, req, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};
export const getAllRider = async ({ signal }) => {
  const { data } = await axios.get("delivery/getRider", { signal });
  return data.data;
};

export const getAllDeliveryOrder = async ({ signal }) => {
  const { data } = await axios.get("delivery/getOrderDetails", { signal });
  return data.data;
};
export const deliveryAdd = async ({ signal, req }) => {
  const { data } = await axios.post("delivery/add", req, { signal });
  return data;
};

export const CourierOrdersList = async ({ queryKey, signal }) => {
  const req = {
    riderID: queryKey[2] === "" ? undefined : +queryKey[2],
    schoolID: queryKey[3] === "" ? undefined : +queryKey[3],
    packageID: queryKey[4] === "" ? undefined : +queryKey[4],
    status: queryKey[5] === "" ? undefined : queryKey[5],
    fromDate: queryKey[6] ?? undefined,
    toDate: queryKey[7] ?? undefined,
    shippingType: queryKey[8] === "" ? undefined : +queryKey[8],
    year: queryKey[9] && queryKey[9].length ? queryKey[9].join(',') : new Date().getFullYear().toString(),

  };
  const { data } = await axios.post("orders/company/filterList/company", req, { signal });
  return data.data;
};

export const schoolList = async ({ signal }) => {
  const { data } = await axios("school/list", { signal });
  return data;
};
export const packageList = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "package/company/List",
    { schoolID: queryKey[1] },
    { signal }
  );
  return data;
};

export const ordersUpdate = async ({ signal, req }) => {
  const { data } = await axios.post("delivery/updateDelivery", req, { signal });
  return data;
};
